<template>
	<div class="f-checkbox" v-if="field.name">
		<div class="st-checkbox">
			<input
			type="checkbox"
			class="st-checkbox__input"

			v-validate="getFieldValidation(field)"
			v-model="value"
			:autocomplete="field.autocomplete"
			:disabled="systemdisable"
			:class="{'st-checkbox__input': errors.has(field.name)}"
			:id="field.name"
			:name="field.name">
			<label :for="field.name" class="st-checkbox__label"></label>
		</div>
	</div>
</template>

<script>

import fieldvalidation from '@/helpers/fieldvalidation';

export default {
	name: 'f-checkbox',
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return field.value
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		},
		autocommit: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		...fieldvalidation
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/f-checkbox.vue